import React from "react";

const Gap = ({ width = 0, height = 0 }) => {
    return <div style={{ width, height }}></div>;
};

export default Gap;
